module.exports = __webpack_public_path__ + "img/service.d1b1f416.jpg";